import {useEffect, useState} from "react";
import {Grid, Popover, Typography} from '@mui/material'
import Tarjeta_Asesor from "../Tarjetas/Tarjeta_Asesor";
import {obtenerCol} from "../../Servicios/BD/obtenerCol";

export const useBotonWass = () => {
    const [open, setOpen] = useState(false)
    const [asesores, setAsesores] = useState([])
    const [anchor, setAnchor] = useState(null)

    const abrir = (target) => {

        setAnchor(target)
        setOpen(true)
    }


    const Vista = () => {
        return (
            <Popover
                open={open}
                anchorEl={anchor}
                onClose={() => setOpen(false)}
                anchorOrigin={{
                    vertical: 'top',
                    horizontal: 'left',
                }}

                transformOrigin={{
                    vertical: 'bottom',
                    horizontal: 'left'
                }}
                slotProps={{
                    paper: {
                        sx: {
                            boxShadow: '0px 8px 12px 0px #00000014',
                            borderRadius: 2
                        }

                    }
                }}

            >

                <Grid
                    container
                    direction="row"
                    justifyContent="flex-start"
                    alignItems="flex-start"
                    size={12}
                    sx={{width: 310, pb: 1}}
                >

                    <Grid item container size={12}
                          sx={{justifyContent: 'flex-start'}}>
                        <Grid
                            container
                            direction="row"
                            justifyContent="flex-start"
                            alignItems="flex-start"
                            size={12}
                            sx={{backgroundColor: '#25D366', p: 2}}
                        >

                            <Grid item container size={12}
                                  sx={{justifyContent: 'center'}}>
                                <Typography sx={{
                                    color: '#fff',
                                    fontWeight: 600,
                                    fontSize: 16,
                                    lineHeight: 1.1,
                                    textAlign: 'center'
                                }}>Chat WhatsApp</Typography>
                            </Grid>


                        </Grid>
                    </Grid>

                    <Grid
                        container
                        direction="row"
                        justifyContent="flex-start"
                        alignItems="flex-start"
                        size={12}
                        sx={{px: 1}}
                    >

                        {asesores.map((item, index) => {
                            return (
                                <Grid item container size={12}
                                      sx={{justifyContent: 'flex-start', marginTop: 1}}>
                                    <Tarjeta_Asesor item={item}/>
                                </Grid>
                            )
                        })}

                    </Grid>


                </Grid>

            </Popover>
        )
    }


    useEffect(() => {

        obtenerCol('asesores').then((dox) => {
            if (dox.res) {
                setAsesores(dox.data)
            }
        })

    }, []);
    return {
        abrir,
        Vista
    }

}